import { render, staticRenderFns } from "./serviceManage.vue?vue&type=template&id=d47b8ea0"
import script from "./serviceManage.vue?vue&type=script&lang=js"
export * from "./serviceManage.vue?vue&type=script&lang=js"
import style0 from "./serviceManage.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports